import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LiaService } from '@app/shared/services/lia.service';
import { ApplicationService } from '@app/shared/application/application.service';

@Injectable()
export class LiaGuard implements CanActivate {

    constructor(
        private liaService: LiaService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.liaService.getLia(this.applicationService.caseId).pipe(map(() => true));
    }
}
